export default __webpack_public_path__ + "static/discord-72bad96ff4cce7a8bf73a074c82d98d2.png";